module.exports = __webpack_public_path__ + "img/31d83ad.jpg";